/**
 * @module components/AlertLoading
 * @author Charles Blais <charles.blais@canada.ca>
 */

import React from 'react';
import { Alert } from 'react-bootstrap';

import { useLanguageState } from '../contexts/LanguageProvider';

const AlertLoading = () => {
  const [ lang ] = useLanguageState();
  return (
    <Alert>
      <p><strong>{lang.loading}</strong> {lang.loadingDetails}</p>
    </Alert>
  );
}

export default AlertLoading;